// third-party
import { createSlice } from '@reduxjs/toolkit';

// ==============================|| SLICE - CONFIRM DIALOG ||============================== //

const slice = createSlice({
    name: 'confirmDialog',
    initialState: {
        open: false,
        title: '',
        dialogMsg: '',
        actionUnderway: false,
        btnAccept: true,
        btnCancel: true,
        btnAcceptText: '',
        btnCancelText: '',
        closeOnProceed: false,
        handleCloseDialog: () => {},
        handleProceedAction: () => {}
    },
    reducers: {
        openConfirmDialog(state, action) {
            const {
                title,
                dialogMsg,
                btnAccept,
                btnCancel,
                closeOnProceed,
                handleCloseDialog,
                handleProceedAction,
                btnAcceptText,
                btnCancelText
            } = action?.payload || {};

            state.open = true;
            state.title = title || null;
            state.dialogMsg = dialogMsg || null;
            state.btnAccept = btnAccept !== undefined ? Boolean(btnAccept) : true;
            state.btnCancel = btnCancel !== undefined ? Boolean(btnCancel) : true;
            state.btnAcceptText = btnAcceptText || '';
            state.btnCancelText = btnCancelText || '';
            state.closeOnProceed = closeOnProceed !== undefined ? Boolean(closeOnProceed) : false;
            state.handleCloseDialog = handleCloseDialog || (() => {});
            state.handleProceedAction = handleProceedAction || (() => {});
        },
        closeConfirmDialog(state) {
            state.open = false;
        },
        setActionUnderway(state, action) {
            state.actionUnderway = Boolean(action?.payload);
        }
    }
});

export default slice.reducer;

export const { openConfirmDialog, closeConfirmDialog, setActionUnderway } = slice.actions;
